var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import ModifyConfig from "~/components/system-manage/strategy-config/modify-config.vue";
import { StrategyConfigService } from "~/services/dataimp-service/strategy-config.service";
import PolicyExecutionRecord from "~/components/system-manage/strategy-config/policy-execution-record.vue";
var StrategyConfig = /** @class */ (function (_super) {
    __extends(StrategyConfig, _super);
    function StrategyConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "";
        _this.policyId = "";
        _this.stategyName = "";
        _this.dialogTitle = "";
        // 数据列表
        _this.dataSet = [];
        // 当前行数据
        _this.rowData = null;
        // 弹框控制
        _this.dialog = {
            config: false,
            record: false
        };
        _this.disabledData = false;
        _this.show = false;
        _this.model = {
            name: "",
            strategyStatus: "",
            executionFrequency: "",
        };
        return _this;
    }
    StrategyConfig.prototype.refreshData = function () {
        var _this = this;
        this.strategyConfigService
            .queryStrategyConfigPage(this.model, this.pageService)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    StrategyConfig.prototype.mounted = function () {
        this.refreshData();
    };
    StrategyConfig.prototype.onSuccess = function () {
        var _this = this;
        this.$nextTick(function () { return (_this.id = ""); });
        this.refreshData();
    };
    /**
     * 删除
     */
    StrategyConfig.prototype.deletedClick = function (scope) {
        var _this = this;
        this.$confirm("是否确定删除该策略?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(function () {
            _this.strategyConfigService.delete(scope.row.id).subscribe(function (data) {
                _this.$message.success("删除成功");
                _this.refreshData();
            });
        });
    };
    /**
     * 新增点击
     */
    StrategyConfig.prototype.addClick = function () {
        this.id = "";
        this.dialogTitle = "新增策略";
        this.disabledData = false;
        this.show = true;
        this.dialog.config = true;
    };
    /**
     * 修改点击
     */
    StrategyConfig.prototype.modifyClick = function (scope) {
        this.id = scope.row.id;
        this.dialogTitle = "修改策略";
        this.disabledData = false;
        this.show = false;
        this.dialog.config = true;
    };
    StrategyConfig.prototype.viewConfig = function (scope) {
        this.id = scope.row.id;
        this.dialogTitle = "查看策略";
        this.disabledData = false;
        this.show = false;
        this.dialog.config = true;
    };
    /**
     * 删除点击
     */
    StrategyConfig.prototype.deleteClick = function (scope) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u5220\u9664\u8BE5\u7B56\u7565\u5417\uFF1F", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(function () {
            var deleteId = scope.row.id;
            _this.strategyConfigService.delete(deleteId).subscribe(_this.refreshData);
        });
    };
    /**
     * 执行记录
     */
    StrategyConfig.prototype.executionRecordClick = function (scope) {
        this.stategyName = scope.row.name;
        this.policyId = scope.row.id;
        this.dialog.record = true;
    };
    __decorate([
        Dependencies(StrategyConfigService)
    ], StrategyConfig.prototype, "strategyConfigService", void 0);
    __decorate([
        Dependencies(PageService)
    ], StrategyConfig.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], StrategyConfig.prototype, "sortService", void 0);
    StrategyConfig = __decorate([
        Auth(18),
        Layout("workspace"),
        Component({
            components: {
                ModifyConfig: ModifyConfig,
                PolicyExecutionRecord: PolicyExecutionRecord
            }
        })
    ], StrategyConfig);
    return StrategyConfig;
}(Vue));
export default StrategyConfig;
